export default {
  login: {
    txt1: "Código secreto del juego",
    txt2: "Ingresa el código secreto...",
    txt3: "Verificar",
    txt4: "Selecciona tu servidor",
    txt5: "Selecciona tu UID",
    txt6: "Iniciar sesión",
    txt7: "Centro de Ayuda",
    txt8: "Código Inválido"
  },
  nav: {
    txt1: "Inicio",
    txt2: "Transmisión en directo",
    txt3: "Tablón de anuncios",
    txt4: "赛事MVP",
    txt5: "Ver el partido",
    txt6: "直播互动领周边",
    txt7: "Recompensas",
    txt8: "赛事创作者计划",
  },
  live: {
    txt1: "Partidos",
    txt2: "Más Retransmisiones",
    txt3: "Tiempo en Directo:",
    txt4: "Transmisión en directo:",
    txt5: "Ir a Retransmisiones",
    txt6: "Tiempo en Directo",
    txt7: "Enfrentamiento",
    txt8: "Hola, inicia sesión primero",
  },
  process: {
    nav1: "Clasificación de los Partidos de Puntos",
    nav2: "Eliminación - Ruta de Clasificación",
    nav3: "Ranking de Puntos",
    txt1: "Ranking",
    txt2: "Equipo",
    txt3: "Servidor",
    txt4: "Punto",
    txt5: "División",
    txt6: "Asesinato",
    list: ["赛区Ⅰ", "赛区Ⅱ", "赛区Ⅲ", "赛区Ⅳ"],
    img: require("@/assets/zh-img.jpg"),
  },
  periphery: {
    time1: "2023/11/22",
    title1: "福利一:半决赛-第一场比赛神秘礼包码",
    time2: "2023/11/24",
    title2: "福利二:半决赛-第二场比赛神秘礼包码",
    time3: "2023/11/25",
    title3: "福利三:冠军队伍福利礼包码",
    p1: "竞猜币",
    p2: "Diamante",
    p3: "公会奖章箱",
    p4: "大型zeny宝箱",
    p5: "卡片抽奖券（珍稀）",
    p6: "高级精炼附魔礼盒",
  },
  mvp: {
    txt1: "历史最高数据",
    txt2: "角色服务器",
    txt3: "战队昵称",
    txt4: "角色昵称",
    txt5: "角色等级",
    txt6: "职业",
    txt7: "32强淘汰赛",
    txt8: "总决赛",
  },
  task: {
    loginTip: "Querido(a) trotamundos, ¡por favor, inicia sesión primero!",
    reward830: "Paquete Opc. de Delot *10\n Material de Camino Nebuloso *50",
    task830: "Ver partidos durante <span>10 min</span> el 30/09",
    reward91: "Polvo de Delot *300\n Material de Camino Nebuloso *50",
    task91: "Ver partidos durante <span>10 min</span> el 02/10",
    reward92: "Paquete de Sigilo Valioso *5 \nMaterial de Camino Nebuloso *100",
    task92: "Ver partidos durante <span>10 min</span> el 04/10",
    reward94: "Pluma Sagrada de Tiempo-Espacio *15 \nPluma Sagrada de Luz-Oscuridad *15",
    task94: "Ver partidos durante <span>15 min</span> el 09/10",
    reward96: "Pluma Sagrada de Tiempo-Espacio *15 \nPluma Sagrada de Luz-Oscuridad *15",
    task96: "Ver partidos durante <span>15 min</span> el 11/10",
    reward98: "Paquete de Módulo Tipo D *3 Paquete de Módulo Tipo C *5 Diamante *500",
    task98: "Ver partidos durante <span>15 min</span> el 13/10",
    rewardTotal2: "Cofre Opc. de Monedas de Encantamiento *5 \nSaco de Edén (G) *15",
    taskTotal2: "Completar 3 misiones de visualización",
    rewardTotal5: "Cupón de Carta Singular *10 Cupón de Gacha *10 Cupón de Súpermascota *10",
    taskTotal5: "Completar 6 misiones de visualización",
    txt7: "Progreso actual",
    txt8: "Sin terminar",
    txt9: "Ver",
    txt10: "Reclamar",
    txt11: "Reclamado",
  },
  reward: [
    {
      type: "Eliminación",
      item: [
        {
          name: "Campeón",
          image: require("@/assets/lna/re1.png"),
          imageM: require("@/assets/lna/mobile/re1.png"),
          list: [
            {
              name: "Montura del Campeón",
              amount: "",
            },
            {
              name: "Título: Campeón de la Copa Thor (2024)",
              amount: "",
            },
            {
              name: "Burbuja de Chat: Campeón de la Copa Thor",
              amount: "",
            },
            {
              name: "Marco de Retrato: Campeón de la Copa Thor",
              amount: "",
            },
            {
              name: "Cartel del Campeón",
              amount: "20",
            },
            {
              name: "Nyan Berry",
              amount: "20000",
            },
            {
              name: "Diamante",
              amount: "5000",
            },
            {
              name: "Cofre Opc. de Sigilo Naranja",
              amount: "10",
            },
            {
              name: "Caja Opc. de Estatuas D",
              amount: "30",
            },
            {
              name: "Cofre Opc. de Luz y Oscuridad",
              amount: "40",
            },
            {
              name: "Capítulo de la Luna",
              amount: "5",
            },
            {
              name: "Cofre Opc. de Partes de Estatua de Rey",
              amount: "10",
            },
          ],
        },
        {
          name: "Subcampeón",
          image: require("@/assets/lna/re2.png"),
          imageM: require("@/assets/lna/mobile/re2.png"),
          list: [
            {
              name: "Título: Subcampeón de la Copa Thor (2024)",
              amount: "",
            },
            {
              name: "Burbuja de Chat: Subcampeón de la Copa Thor",
              amount: "",
            },
            {
              name: "Marco de Retrato: Subcampeón de la Copa Thor",
              amount: "",
            },
            {
              name: "Cartel del Campeón",
              amount: "20",
            },
            {
              name: "Nyan Berry",
              amount: "10000",
            },
            {
              name: "Diamante",
              amount: "4500",
            },
            {
              name: "Cofre Opc. de Sigilo Naranja",
              amount: "10",
            },
            {
              name: "Caja Opc. de Estatuas D",
              amount: "25",
            },
            {
              name: "Cofre Opc. de Luz y Oscuridad",
              amount: "36",
            },
            {
              name: "Capítulo de la Luna",
              amount: "4",
            },
            {
              name: "Cofre Opc. de Partes de Estatua de Rey",
              amount: "8",
            },
          ],
        },
        {
          name: "Top 3 - 4",
          image: require("@/assets/lna/re3.png"),
          imageM: require("@/assets/lna/mobile/re3.png"),
          list: [
            {
              name: "Título: Top 4 de la Copa Thor (2024)",
              amount: "",
            },
            {
              name: "Burbuja de Chat: Top 4 de la Copa Thor",
              amount: "",
            },
            {
              name: "Marco de Retrato: Top 4 de la Copa Thor",
              amount: "",
            },
            {
              name: "Cartel del Campeón",
              amount: "17",
            },
            {
              name: "Nyan Berry",
              amount: "5000",
            },
            {
              name: "Diamante",
              amount: "4000",
            },
            {
              name: "Cofre Opc. de Sigilo Naranja",
              amount: "8",
            },
            {
              name: "Caja Opc. de Estatuas D",
              amount: "20",
            },
            {
              name: "Cofre Opc. de Luz y Oscuridad",
              amount: "32",
            },
            {
              name: "Capítulo de la Luna",
              amount: "3",
            },
            {
              name: "Cofre Opc. de Partes de Estatua de Rey",
              amount: "6",
            },
          ],
        },
        {
          name: "Top 5 - 8",
          image: require("@/assets/lna/re4.png"),
          imageM: require("@/assets/lna/mobile/re4.png"),
          list: [
            {
              name: "Título: Top 8 de la Copa Thor (2024)",
              amount: "",
            },
            {
              name: "Burbuja de Chat: Top 8 de la Copa Thor",
              amount: "",
            },
            {
              name: "Marco de Retrato: Top 8 de la Copa Thor",
              amount: "",
            },
            {
              name: "Cartel del Campeón",
              amount: "15",
            },
            {
              name: "Nyan Berry",
              amount: "3000",
            },
            {
              name: "Diamante",
              amount: "3000",
            },
            {
              name: "Cofre Opc. de Sigilo Naranja",
              amount: "6",
            },
            {
              name: "Caja Opc. de Estatuas D",
              amount: "15",
            },
            {
              name: "Cofre Opc. de Luz y Oscuridad",
              amount: "28",
            },
            {
              name: "Capítulo de la Luna",
              amount: "2",
            },
            {
              name: "Cofre Opc. de Partes de Estatua de Rey",
              amount: "4",
            },
          ],
        },
        {
          name: "Top 9 - 16",
          image: require("@/assets/lna/re5.png"),
          imageM: require("@/assets/lna/mobile/re5.png"),
          list: [
            {
              name: "Título: Top 16 de la Copa Thor (2024)",
              amount: "",
            },
            {
              name: "Burbuja de Chat: Top 32 de la Copa Thor",
              amount: "",
            },
            {
              name: "Marco de Retrato: Top 32 de la Copa Thor",
              amount: "",
            },
            {
              name: "Cartel del Campeón",
              amount: "7",
            },
            {
              name: "Nyan Berry",
              amount: "2000",
            },
            {
              name: "Diamante",
              amount: "2000",
            },
            {
              name: "Cofre Opc. de Sigilo Naranja",
              amount: "4",
            },
            {
              name: "Caja Opc. de Estatuas D",
              amount: "10",
            },
            {
              name: "Cofre Opc. de Luz y Oscuridad",
              amount: "24",
            },
            {
              name: "Capítulo de la Luna",
              amount: "2",
            },
            {
              name: "Cofre Opc. de Partes de Estatua de Rey",
              amount: "2",
            },
          ],
        },
        {
          name: "Top 17 - 32",
          image: require("@/assets/lna/re6.png"),
          imageM: require("@/assets/lna/mobile/re6.png"),
          list: [
            {
              name: "Título: Top 32 de la Copa Thor (2024)",
              amount: "",
            },
            {
              name: "Burbuja de Chat: Top 32 de la Copa Thor",
              amount: "",
            },
            {
              name: "Marco de Retrato: Top 32 de la Copa Thor",
              amount: "",
            },
            {
              name: "Cartel del Campeón",
              amount: "5",
            },
            {
              name: "Nyan Berry",
              amount: "1500",
            },
            {
              name: "Diamante",
              amount: "1500",
            },
            {
              name: "Cofre Opc. de Sigilo Naranja",
              amount: "2",
            },
            {
              name: "Caja Opc. de Estatuas D",
              amount: "5",
            },
            {
              name: "Cofre Opc. de Luz y Oscuridad",
              amount: "20",
            },
            {
              name: "Capítulo de la Luna",
              amount: "1",
            },
          ],
        },
      ],
    },
    {
      type: "Partidos de Puntos",
      item: [
        {
          name: "Avance 1-4",
          image: require("@/assets/lna/re7.png"),
          imageM: require("@/assets/lna/mobile/re7.png"),
          list: [
            {
              name: "Título: Élite de la Copa Thor",
              amount: "",
            },
            {
              name: "Burbuja de Chat: : Élite de la Copa Thor",
              amount: "",
            },
            {
              name: "Marco de Retrato: Élite de la Copa Thor",
              amount: "",
            },
            {
              name: "Cartel del Campeón",
              amount: "40",
            },
            {
              name: "Nyan Berry",
              amount: "2500",
            },
            {
              name: "Diamante",
              amount: "2500",
            },
            {
              name: "Cofre Opc. de Sigilo Naranja",
              amount: "3",
            },
            {
              name: "Caja Opc. de Estatuas D",
              amount: "30",
            },
            {
              name: "Cofre Opc. de Luz y Oscuridad",
              amount: "30",
            },
            {
              name: "Cofre Opc. de Espacio-Tiempo",
              amount: "50",
            },
            {
              name: "Retrato: Élite de la Copa Thor",
              amount: "",
            },
          ],
        },
        {
          name: "Avance 5-8",
          image: require("@/assets/lna/re7.png"),
          imageM: require("@/assets/lna/mobile/re7.png"),
          list: [
            {
              name: "Título: Élite de la Copa Thor",
              amount: "",
            },
            {
              name: "Burbuja de Chat: : Élite de la Copa Thor",
              amount: "",
            },
            {
              name: "Marco de Retrato: Élite de la Copa Thor",
              amount: "",
            },
            {
              name: "Cartel del Campeón",
              amount: "35",
            },
            {
              name: "Nyan Berry",
              amount: "2300",
            },
            {
              name: "Diamante",
              amount: "2300",
            },
            {
              name: "Cofre Opc. de Sigilo Naranja",
              amount: "3",
            },
            {
              name: "Caja Opc. de Estatuas D",
              amount: "25",
            },
            {
              name: "Cofre Opc. de Luz y Oscuridad",
              amount: "25",
            },
            {
              name: "Cofre Opc. de Espacio-Tiempo",
              amount: "45",
            },
            {
              name: "Retrato: Élite de la Copa Thor",
              amount: "",
            },
          ],
        },
        {
          name: "Avance 9-16",
          image: require("@/assets/lna/re7.png"),
          imageM: require("@/assets/lna/mobile/re7.png"),
          list: [
            {
              name: "Título: Élite de la Copa Thor",
              amount: "",
            },
            {
              name: "Burbuja de Chat: : Élite de la Copa Thor",
              amount: "",
            },
            {
              name: "Marco de Retrato: Élite de la Copa Thor",
              amount: "",
            },
            {
              name: "Cartel del Campeón",
              amount: "33",
            },
            {
              name: "Nyan Berry",
              amount: "2000",
            },
            {
              name: "Diamante",
              amount: "2000",
            },
            {
              name: "Cofre Opc. de Sigilo Naranja",
              amount: "3",
            },
            {
              name: "Caja Opc. de Estatuas D",
              amount: "20",
            },
            {
              name: "Cofre Opc. de Luz y Oscuridad",
              amount: "20",
            },
            {
              name: "Cofre Opc. de Espacio-Tiempo",
              amount: "40",
            },
            {
              name: "Retrato: Élite de la Copa Thor",
              amount: "",
            },
          ],
        },
        {
          name: "Avance 17-32",
          image: require("@/assets/lna/re7.png"),
          imageM: require("@/assets/lna/mobile/re7.png"),
          list: [
            {
              name: "Título: Élite de la Copa Thor",
              amount: "",
            },
            {
              name: "Burbuja de Chat: : Élite de la Copa Thor",
              amount: "",
            },
            {
              name: "Marco de Retrato: Élite de la Copa Thor",
              amount: "",
            },
            {
              name: "Cartel del Campeón",
              amount: "30",
            },
            {
              name: "Nyan Berry",
              amount: "1900",
            },
            {
              name: "Diamante",
              amount: "1900",
            },
            {
              name: "Cofre Opc. de Sigilo Naranja",
              amount: "3",
            },
            {
              name: "Caja Opc. de Estatuas D",
              amount: "15",
            },
            {
              name: "Cofre Opc. de Luz y Oscuridad",
              amount: "19",
            },
            {
              name: "Cofre Opc. de Espacio-Tiempo",
              amount: "38",
            },
            {
              name: "Retrato: Élite de la Copa Thor",
              amount: "",
            },
          ],
        },
        {
          name: "No avanzado",
          image: require("@/assets/lna/re7.png"),
          imageM: require("@/assets/lna/mobile/re7.png"),
          list: [
            {
              name: "Título: Élite de la Copa Thor",
              amount: "",
            },
            {
              name: "Burbuja de Chat: : Élite de la Copa Thor",
              amount: "",
            },
            {
              name: "Marco de Retrato: Élite de la Copa Thor",
              amount: "",
            },
            {
              name: "Cartel del Campeón",
              amount: "28",
            },
            {
              name: "Nyan Berry",
              amount: "1800",
            },
            {
              name: "Diamante",
              amount: "1800",
            },
            {
              name: "Cofre Opc. de Sigilo Naranja",
              amount: "2",
            },
            {
              name: "Caja Opc. de Estatuas D",
              amount: "10",
            },
            {
              name: "Cofre Opc. de Luz y Oscuridad",
              amount: "18",
            },
            {
              name: "Cofre Opc. de Espacio-Tiempo",
              amount: "36",
            },
            {
              name: "Retrato: Élite de la Copa Thor",
              amount: "",
            },
          ],
        },
        {
          name: "Recompensa por Participación",
          image: require("@/assets/lna/re8.png"),
          imageM: require("@/assets/lna/mobile/re8.png"),
          list: [
            {
              name: "Diamante",
              amount: "100",
            },
            {
              name: "Marca del Poderoso",
              amount: "200",
            },
            {
              name: "Paquete Aleatorio de Sigilo Raro",
              amount: "1",
            },
            {
              name: "Cofre Opc. de Espacio-Tiempo",
              amount: "5",
            },
            {
              name: "Súpergalleta",
              amount: "5",
            },
            {
              name: "Cofre Opc. de Pluma Morada",
              amount: "10",
            },
          ],
        },
      ],
    },
  ],
  dia: {
    txt1: "Códigos de Regalo",
    txt2: "Copiar",
    txt3: "Copiado",
  },
};
